import { CustomerReferralReport } from '@/services/dashboard/referralReports/referralReports.types';

export interface CustomerReferralRow {
  referralId: string;
  referrerId: string;
  referrerName: string;
  referrerNickname: string;
  reservedBy: string;
  reservedByNickname: string;
  reservationDateTime: number;
  pointsEarned: number | null;
  stageDetails: string;
  receiptDateTime: number | null;
}

export const mapCustomerReferralReports = (reports: CustomerReferralReport[], locale: string): CustomerReferralRow[] =>
  reports.map((report, index) => ({
    referralId: `${report.referrerCustomerId}-${report.referredCustomerId}-${report.reservationDateTimeMs}-${report.rewardTransactionDateTimeMs}-${index}`,
    referrerId: report.referrerCustomerId,
    referrerName: report.referrerCustomerFullname?.trim() || '-',
    referrerNickname: report.referrerCustomerNickname?.trim() || '-',
    reservedBy: report.referredCustomerFullname?.trim() || '-',
    reservedByNickname: report.referredCustomerNickname?.trim() || '-',
    reservationDateTime: report.reservationDateTimeMs,
    pointsEarned: report.rewardAmount,
    stageDetails:
      (locale === 'ja' ? report.stageDetailJp || report.stageDetail : report.stageDetail || report.stageDetailJp) ||
      '-',
    receiptDateTime: report.rewardTransactionDateTimeMs,
  }));
